import type {
  ErrorHandledResponse,
  FrisbeeClientError,
} from '@shared/types/frontend/ubff-gateway';

import { UBFF_REMOTECLIENTS_CALLS } from '@shared/constants/newrelic-events/event-names';
import { SKYSCANNER_CORRELATION_ID } from '@shared/constants/ubff-gateway';
import logger from '@shared/utils-frontend/logger';

const FALLBACK_ERROR_CODE = -1;

const instrumentedFrisbeeClientFetch =
  <T extends unknown[], R>({
    correlationId,
    func,
  }: {
    func: (...arg: T) => Promise<R>;
    correlationId: string;
  }) =>
  async (...arg: T): Promise<ErrorHandledResponse<R>> => {
    let errorCode;
    const startTime = Date.now();
    try {
      return { response: await func(...arg), error: null };
    } catch (err) {
      const clientError = err as FrisbeeClientError;
      errorCode = clientError?.code ?? FALLBACK_ERROR_CODE;
      return { response: null, error: clientError };
    } finally {
      const duration = Date.now() - startTime;

      logger.event(UBFF_REMOTECLIENTS_CALLS, {
        [SKYSCANNER_CORRELATION_ID]: correlationId,
        function: func.name,
        duration,
        errorCode,
      });
    }
  };

export default instrumentedFrisbeeClientFetch;
